import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseComponent, LocalizationService } from '@mds/angular-core-material';
import { TVP_TOOLBAR_LOGO, toolbarLogo } from '@tvp/common';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BrandingService } from './modules/common/services/branding.service';

@Component({
  selector: 'tvp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent {
  constructor(
    localizationService: LocalizationService,
    private brandingService: BrandingService,
    private metaService: Meta,
    private title: Title,
    @Inject(TVP_TOOLBAR_LOGO) public logoSubject: ReplaySubject<string>,
    @Inject(DOCUMENT) private document: Document,
    injector: Injector
  ) {
    super(injector);
    localizationService.init();
    this.initBranding();
  }

  private initBranding(): void {
    this.brandingService.branding$.subscribe((brandingAndStylesheet) => {
      if (brandingAndStylesheet?.stylesheet) {
        this.addStylesheet(brandingAndStylesheet.stylesheet);
      }

      if (brandingAndStylesheet?.branding) {
        const branding = brandingAndStylesheet?.branding;
        this.addThemeColor(branding.primaryColor);
        this.logoSubject.next(`data:image/png;base64,${branding.logo}`);
      } else {
        this.addThemeColor('#8d1423');
        this.logoSubject.next(toolbarLogo.src);
      }

      const params = { name: brandingAndStylesheet?.branding?.brandingIdentifier ?? 'Planzer' };
      this.translateOnChange(_('Tvp.App.Title'), params)
        .pipe(takeUntil(this.destroy$))
        .subscribe((title) => {
          this.title.setTitle(title);
        });
    });
  }

  private addThemeColor(color: string): void {
    this.metaService.addTag({ name: 'theme-color', content: color });
    this.metaService.addTag({ name: 'msapplication-TileColor', content: color });
  }

  private addStylesheet(css: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('style');
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
  }
}
